export default "__VITE_ASSET__3f97464c__"